"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapWithComponent = void 0;
var react_1 = __importStar(require("react"));
var react_is_1 = require("react-is");
var isElementOfType_1 = require("./isElementOfType");
/*
 * Wraps `element` in `Component`, if it is not already an instance of
 * `Component`. If `props` is passed, those will be added as props on the
 * wrapped component. If `element` is null, the component is not wrapped.
 */
var wrapWithComponent = function (element, Component, props) {
    var childArray = react_is_1.isFragment(element) ? element.props.children : element;
    var toArray = react_1.Children.toArray(childArray);
    var hasSections = toArray.some(function (child) {
        return isElementOfType_1.isElementOfType(child, Component);
    });
    if (hasSections)
        return element;
    return react_1.default.createElement(Component, __assign({}, props), element);
};
exports.wrapWithComponent = wrapWithComponent;
//# sourceMappingURL=wrapWithComponent.js.map